import * as React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import CancelIcon from '@mui/icons-material/Cancel';

export const ConclusionStatus = {
  Approved: 1,
  ApprovedWithMinorErrors: 2,
  NotApproved: 3,
} as const;

const CONCLUSION_CONFIG: Record<number, { icon: React.ReactElement; color: string; translationKey: string }> = {
  [ConclusionStatus.Approved]: {
    icon: <CheckCircleIcon />,
    color: '#4caf50',
    translationKey: 'tasks.service.approved',
  },
  [ConclusionStatus.ApprovedWithMinorErrors]: {
    icon: <WarningIcon />,
    color: '#ff9800',
    translationKey: 'tasks.service.approved_minor',
  },
  [ConclusionStatus.NotApproved]: {
    icon: <CancelIcon />,
    color: '#f44336',
    translationKey: 'tasks.service.not_approved',
  },
};

export const getConclusionIcon = (statusValue: number): React.ReactElement | null => {
  const config = CONCLUSION_CONFIG[statusValue];
  if (!config) return null;
  return React.cloneElement(config.icon, { style: { color: config.color } });
};

export const CONCLUSION_OPTIONS = Object.entries(CONCLUSION_CONFIG).map(([value, config]) => ({
  value,
  icon: React.cloneElement(config.icon, { style: { color: config.color } }),
  translationKey: config.translationKey,
}));
